<template>
  <div class="report-container">
    <div class="bg-logo">
      <span class="logo_text">该鉴别报告由图灵鉴定小程序提供</span>
    </div>
    <div class="flex-body">
      <div class="info_content">
        <div class="report-header"></div>
        <div :class="`report-content ${isManual ? 'sub-bottom' : ''}`">
          <div class="brief-info">
            <div class="left">
              <div class="info_desc_line">
                <div class="desc_label">鉴别结果</div>
                <div class="desc_content">
                  <span>{{ genuineType.desp }}</span>
                  <span v-if="genuineType.code == 33" class="patch" @click="patch">去补图</span>
                </div>
              </div>
              <div class="info_desc_line">
                <div class="desc_label">鉴别品牌</div>
                <div class="desc_content">{{brandName}}</div>
              </div>
              <div class="info_desc_line" v-clipboard="OAID" v-clipboard:success="onCopy">
                <div class="desc_label">鉴别编号</div>
                <div class="desc_content has_cp_afterfix">{{OAID}}</div>
              </div>
              <div class="info_desc_line" :style="{'margin-bottom': kindID===129 && cardRatings.length ? '41px':''}">
                <div class="desc_label">CODE</div>
                <div class="desc_content">{{sequence}}</div>
              </div>
              <div v-if="appraisalRemark" class="info_desc_line" :style="{}">
                <div class="desc_label">评价</div>
                <div class="desc_content __wp">{{appraisalRemark}}</div>
              </div>
              <div v-if="kindID===129 && cardRatings.length" class="score_container">
                <div class="score_item">
                  <div class="title">总分</div>
                  <div class="score">{{ cardRatings[0].grade/100 }}分</div>
                </div>
                <div class="score_item">
                  <div class="title">四边</div>
                  <div class="score">{{ cardRatings[3].grade/100 }}分</div>
                </div>
                <div class="score_item">
                  <div class="title">四角</div>
                  <div class="score">{{ cardRatings[2].grade/100 }}分</div>
                </div>
                <div class="score_item">
                  <div class="title">表面</div>
                  <div class="score">{{ cardRatings[4].grade/100 }}分</div>
                </div>
                <div class="score_item">
                  <div class="title">居中</div>
                  <div class="score">{{ cardRatings[1].grade/100 }}分</div>
                </div>
              </div>
            </div>
            <div class="right">
              <img :src="genuineType.sealImg" />
            </div>
          </div>

          <!-- <div v-if="!genuineType()" class="picc"></div> -->
          <div class="icon-line"></div>


        </div>
      </div>
      <!-- 详情 -->
      <div class="detail_content">
        <!-- 滑动 -->
        <div class="tab-bar">
          <perfect-scrollbar>
            <div class="scroll-view">
              <div v-for="(t, i) in newSARecordList" :key="i" class="box">
                <div :class="{ item: true }">
                  <van-image :show-loading="false" :src="t.image" class="item" fit="contain"
                    @click="changeGrade(t, i)"></van-image>
                  <div :class="{ tag: true, 'tag-active': tabActive === i }">
                    {{ t.pointName }}
                  </div>
                  <van-image @click="(e) => showImage(e, i)" :show-loading="false" class="show-icon"
                    src="https://oss.turingsenseai.com/1650956009715204926.png"></van-image>
                </div>
              </div>
            </div>
          </perfect-scrollbar>
        </div>

        <!-- 鉴定点分数详情 -->
        <div class="detail_grade">
          <Precent v-show="nowGrade" :grade="nowGrade"></Precent>
          <div class="point_dsc">
            <p>{{ nowDescription }}</p>
          </div>
          <p class="dsc_tip">
            图灵鉴定依据中质协AI鉴定团体标准对商品外观、纹理、质地进行
            检测，通过10万个特征点得出公正，客观，准确的检测结果
          </p>
        </div>

      </div>
    </div>
    <div class="text111">
      <div>1、本报告属于图片鉴别报告，鉴别结果根据用户上传商品图片给出</div>
      <div>2、本报告可以给商家销售和买家购物提供参考价值</div>
      <div>3、本报告不等同于有法律效力的线下实物鉴定报告</div>
      <div>4、本报告受用户委托，依据中质协《商品人工智能鉴定方法通用规范》(T/CAQI 268-2022 )团体标准，由符合该团体标准的AI算法自动给出</div>
      <div>5、客服邮箱:{{ reportContactEmail }} 公司官网:{{ reportCompanyWebsite }}</div>
    </div>
    <div class="safe-bottom"></div>

  </div>
</template>

<script>
const SEAL = {
  real: 'https://oss.turingsenseai.com/1663065727982709745.png',
  fake: 'https://oss.turingsenseai.com/1666691981753319068.png',
  unknow: 'https://oss.turingsenseai.com/1628582036592914079.png'
}
const GENUINE_TYPE = {
  '0': {
    desp: '不符合正品工艺',
    sealImg: 'https://oss.turingsenseai.com/1719984567078472945.jpg',
    typeBgClass: 'fake'
  },
  '1': {
    desp: '符合正品工艺',
    sealImg: 'https://oss.turingsenseai.com/1719984569383001375.jpg',
    typeBgClass: 'real'
  },
  '2': {
    desp: '无法鉴定',
    sealImg: 'https://oss.turingsenseai.com/1628582036592914079.png',
    typeBgClass: 'fake'
  },
  '3': {
    desp: '待补图',
    sealImg: 'https://oss.turingsenseai.com/1628582036592914079.png',
    typeBgClass: '',
    code: 33
  },
  '4': {
    desp: '预计4-24小时内出结果，请耐心等待。',
  }
}

const AITOMANUAL_TYPE = {
  0: {
    desp: '预计4-24小时内出结果，请耐心等待。',
  },
  2: {
    desp: '不符合正品工艺',
    sealImg: 'https://oss.turingsenseai.com/1719984567078472945.jpg',
    typeBgClass: 'fake'
  },
  1: {
    desp: '符合正品工艺',
    sealImg: 'https://oss.turingsenseai.com/1719984569383001375.jpg',
    typeBgClass: 'real'
  },
  3: {
    desp: '无法鉴定',
    sealImg: 'https://oss.turingsenseai.com/1628582036592914079.png',
    typeBgClass: 'fake'
  },
  5: {
    desp: '待补图',
    sealImg: 'https://oss.turingsenseai.com/1628582036592914079.png',
    typeBgClass: '',
    code: 33
  },
}
import Precent from './components/precent.vue'
import { ImagePreview, Toast } from "vant";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import { REPORT_COMPANY_WEBSITE, REPORT_CONTACT_EMAIL } from "@/common/constant";

export default {
  components: {
    Precent,
  },
  props: {
    isManual: {
      type: Boolean,
      default: false
    },
    isPcFlag: {
      type: Boolean,
      default: false,
    },
    appid: {
      type: String,
      required: false,
      default: ""
    },
    brandName: {
      type: String,
      required: true,
      default: ""
    },
    OAID: {
      type: String,
      required: true,
      default: ""
    },
    sequence: {
      type: String,
      require: true,
      default: ""
    },
    SARecordList: {
      type: Array,
      required: true,
      default: []
    },
    aIToManualResult: {
      type: Number,
      default: () => {
        return 3
      }
    },
    genuine: {
      type: String,
      required: true,
      default: '1'
    },
    kindID: {
      type: Number,
      required: true,
    },
    brandID: {
      type: Number,
      required: true,
    },
    seriesID: {
      type: Number,
      required: true,
    },
    hierarchy: {
      type: String,
      required: true,
    },
    appraisalRemark: {
      type: String,
      required: false,
    },
    cardRatings: {
      type: Array,
      default: []
    },
    isToManualRealTimeOrder: {
      type: Boolean
    }
  },
  
  mounted () {
    this.SARecordList.forEach((item, index) => {
      this.newSARecordList.push(item);
      // this.SARecordList.push(item);
    });
    console.log( this.newSARecordList,'**********')
    // while (this.newSARecordList.length <= 5) {
    //   this.newSARecordList.push({
    //     pointName: ''
    //   })
    // }
    this.changeGrade(this.newSARecordList[0],0)
  },
  computed: {
    genuineType() {
      // console.log(GENUINE_TYPE, this)
      console.log(this.genuine, GENUINE_TYPE[this.genuine])
      let showResult = 0
      if(!this.isManual && this.isToManualRealTimeOrder) {
        showResult = this.aIToManualResult
        return AITOMANUAL_TYPE[showResult] || {}
      }else{
        showResult = this.genuine
        return GENUINE_TYPE[showResult] || {}
      }
    }
  },
  data() {
    return {
      showMore: false,
      seal: SEAL,
      screenWidth: document.documentElement.clientWidth, //屏幕宽度
      screenHeight: document.documentElement.clientHeight, //屏幕宽度
      newSARecordList: [],
      nowGrade: '',
      nowDescription: '',
      detailScroll: '',
      tabActive: 0,
      nowPointName: '【鉴定点】',
      reportContactEmail: REPORT_CONTACT_EMAIL,
      reportCompanyWebsite: REPORT_COMPANY_WEBSITE,
    }
  },
  methods: {
    patch(){
      let url;
      if (this.appid === 'wx2974d4d19e8294d4') {
        // 验货宝小程序
        url = `/subPackages/personal/complementGraph/index?oaId=${this.OAID}`
      } else {
        // 兜底 - 一般指的是主站小程序
        if(this.isManual){
          url = `/subPackages/ai/identify/butu/index?oaId=${this.OAID}&guaqian=1`
        }else{
          url = `/subPackages/ai/identify/aiButu/index?oaId=${this.OAID}&key=${[this.kindID, this.brandID, this.seriesID][this.hierarchy]}&guaqian=1`
        }
      }

      if(window.__wxjs_environment === 'miniprogram'){
        wx.miniProgram.redirectTo({
          url,
          success: (res) => {
            console.log(res); // 页面跳转成功
          },
          fail: (err) => {
            console.log(err); // 页面跳转失败
          },
        });
      }else{
        Toast('请前往微信小程序 “我的-我的鉴别挂签” 找到订单，并完成补图操作~');
      }

    },
    showImage(e, index = 0) {
      e.preventDefault();
      e.stopPropagation();
      let images = this.newSARecordList.map((v) => v.image);
      ImagePreview({
        images,
        startPosition: index,
      });
    },
    changeGrade(detailData, i) {
      console.log(detailData,"--------------")
      this.nowDescription = detailData.description
      // 改成一分制
      this.nowGrade = Number(detailData.grade) > 1 ? (Number(detailData.grade)/100).toFixed(2) : Number(detailData.grade)
      this.nowPointName = `【${detailData.pointName}】`
      this.tabActive = i
    },
    onCopy() {
      Toast('复制成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.detail_content {
  background-color: #fff;
  border-radius: 2 * 2px;
  .tab-bar {
    width: 307*2px;
    margin: 0 auto;
    ::v-deep .ps__rail-x {
      height: 0;
      opacity: 0;
      .ps__thumb-x {
        height: 0;
      }
    }
    .scroll-view {
      display: flex;
      height: 94 * 2px;
      // justify-content: flex-start;
      // align-items: flex-start;
      margin-top: 18 * 2px;
      .box {
        background: #35424d;
        margin-right: 20px;
        width: 180px;
        height: 180px;
        border-radius: 2px;
        .item {
          position: relative;
          display: inline-block;
          width: 180px;
          height: 180px;

          .show-icon {
            width: 30px;
            height: 30px;
            position: absolute;
            bottom: 10px;
            right: 10px;
          }

          .tag {
            top: 0px;
            left: 0 px;
            padding: 0 6px;
            height: 28px;
            z-index: 100;
            position: absolute;
            background-color: #efeff4;
            color: #828393;
            font-size: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 2px;
          }
          .tag-active {
            background-color: #3b95ff;
            color: #fff;
          }
        }
        .item-active {
          border-radius: 2px;
          box-shadow: 0 0 0 4px #3a94ff;
        }
      }
    }
  }
  .detail_grade {
    width: 303 * 2px;
    margin: 0 auto;
    .point_dsc{
      margin-top: 20 * 2px;
      width: 303 * 2px;
      // height: 40 * 2px;
      background-color: #f8f8fb;
      font-size: 12 * 2px;
      font-weight: 500;
      p {
        display: inline-block;
        margin: 12 * 2px;
        margin-left: 8 * 2px;
        border-radius: 2 * 2px;
      }
    }
    .dsc_tip {
      display: inline-block;
      margin: 20 * 2px 0;
      font-size: 10 * 2px;
      color: #a8a8b3;
      text-align: center;
    }
  }
}


.report-container {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  // padding: 0 12 * 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 20px;
  // background: linear-gradient(270.23deg, #26262E 0.15%, #4D4D59 99.76%);
}
.bg-logo {
  height: 137 * 2px;
  width: 375 * 2px;
  // margin: 25 * 2px 0;
  // background: url('https://oss.turingsenseai.com/1628564754186096854.png') no-repeat;
  background: url('https://oss.turingsenseai.com/1662345030522135699.png') no-repeat;
  background-size: 100% 100%;
  .logo_text {
    display: flex;
    justify-content: center;
    padding-top: 15 * 2px;
    color: #fff;
    font-size: 12 * 2px;
  }
}
.flex-body {
  margin-top: -95 * 2px;
  width: 343 * 2px;
  position: relative;
  // display: flex;
  // flex-direction: column;
  align-items: center;
  overflow: hidden;
  // background-color: #FFF;
}

.info_content {
    width: 343 * 2px;
    background-color: #fff;
    border-radius: 2 * 2px;
    margin-bottom: 10 * 2px;
}
.report-header {
  display: inline-block;
  margin: 20 * 2px 94 * 2px;
  margin-bottom: 12 * 2px;
  width: 100%;
  height: 36 * 2px;
  background: url('https://oss.turingsenseai.com/1725609612926297664.jpg') no-repeat;
  background-size: contain;
  z-index: 1;
}

.sub-bottom {
  margin-bottom: 0px !important;
  padding-bottom: 10px !important;
}

.report-content {
  width: calc(100% - 16px);
  // margin-bottom: 20px;
  box-sizing: border-box;
  padding: 0 16 * 2px 0 16 * 2px;
  background-color: #FFF;
  color: #222;
  z-index: 1;
  .brief-info {
    width: 100%;
    display: flex;
    align-items: center;
    // border-bottom: 1 * 2px solid #f0f0f5;
    .left {
      display: flex;
      flex-direction: column;
      flex: 1;
      .info_result {
        width: fit-content;
        margin-bottom: 29 * 2px;
        font-size: 24 * 2px;
        line-height: 34 * 2px;
        font-weight: 600;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        &.fake {
          background-size: 32 * 2px 32 * 2px;
          background-image: url("https://oss.turingsenseai.com/1628679595929512302.png");
        }
        &.real { // real
          background-size: 82px 60px;
          background-image: url("https://oss.turingsenseai.com/1628575456562452544.png");
        }
      }
      .info_desc_line {
        display: flex;
        flex-direction: column;
        margin-bottom: 15rpx;
      }
      .desc_label, .desc_content {
        font-size: 16 * 2px;
        line-height: 12* 2px;
        margin-bottom: 9 * 2px;
        &.has_cp_afterfix {
          position: relative;
          &::after {
            content: '复制';
            position: absolute;
            right: 0px;
            top: 0px;
            font-weight: 400;
            font-size: 12 * 2px;
            color: #999;
          }
        }
      }
      .desc_content_afterfix {
      }
      .desc_label {
        font-size: 12 * 2px;
        font-weight: 400;
        color: #828393;
      }
      .desc_content {
        color: #3a3d44;
        white-space: nowrap;
        font-weight: 500;
        margin-bottom: 20 * 2px;
        &.__wp {
          white-space: wrap;
          width: 280 * 2px;
          line-height: 1.2em;
          word-break: break-all;
        }
        .patch {
          font-weight: 400;
          font-size: 12 * 2px;
          margin-left: 20px;
          color: #3a94ff;
          text-decoration: underline;
        }
      }

      .score_container {
        position: absolute;
        top: 570px;
        display: flex;
        justify-content: flex-start;
        font-size: 12*2px;;
        .score_item {
          .title,.score {
            width: 60*2px;
            height: 24*2px;
            line-height: 24*2px;
            border-top: 1*2px solid #F0F0F5;
            border-right: 1*2px solid #F0F0F5;
            text-align: center;
          }
          .score {
            border-bottom: 1*2px solid #F0F0F5;
          }
        }
        .score_item:first-child {
          .title,.score {
            border-left: 1*2px solid #F0F0F5;
          }
        }
      }
    }
    .right {
      width: 135 * 2px;
      height: 126 * 2px;
      margin-left: 20 * 2px;
      margin-right: 8 * 2px;
      overflow: hidden;
      position: relative;
      top: 10 * 2px;
      right: 10 * 2px;
    }
  }

  .icon-line {
    display: inline-block;
    
    height: 19 * 2px;
    width: 297 * 2px;
    margin: 17 * 2px 0;
    background: url('https://oss.turingsenseai.com/1725609612897818121.jpg') no-repeat center;
    background-size:contain;
    background-position-x: 0;
  }

  // .picc {
  //   display: inline-block;
  //   // width: 124 * 2px;
  //   // height: 44 * 2px;
  //   height: 19 * 2px;
  //   width: 297 * 2px;
  //   margin-top: 15 * 2px;
  //   margin-bottom: 14 * 2px;
  //   margin-left: -16px;
  //   background: url('https://oss.turingsenseai.com/1661167727134266912.png') no-repeat center;
  //   background-size: cover;
  // }

  
}
.detail_container {
  margin-top: 12 * 2px;
  // display: flex;
  white-space: nowrap;
  overflow: hidden;
  z-index: 999;
  .container_scroll {
    display: inline-block;
    width: 100%;
  }
  .point_content {
    width: 100%;
    border-top: 1px solid RGB(240, 240, 245);
    .ponit_pic {
      position: relative;
      display: flex;
      align-items: center;
      margin: 20 * 2px 0;
      justify-content: center;
      &.hasFake {
        justify-content: space-between;
      }
      .picT,
      .picF {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        img {
          width: 265px;
          height: 265px;
        }
      }
      .picF {
        position: relative;
        .fake_mark {
          position: absolute;
          border: 1px solid red;
          z-index: 7;
          border-radius: 45px;
          width: 9%;
          height: 8%;
        }
      }
      .pic_markT {
        position: absolute;
        top: 0;
        z-index: 6;
        width: 60%;
        height: 94%;
      }
      .pic_markF {
        position: absolute;
        top: 0;
        z-index: 6;
        height: 3.5rem;
        width: 3.5rem;
      }
      img {
        width: 35%;
        height: 35%;
        background-color: black;
        object-fit: contain;
        margin-bottom: 10px;
      }
      .trueArea {
        position: absolute;
        background-color: rgba(0, 0, 0, 0);
        object-fit: fill;
      }
      // 真
      .trueP {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .truePic {
          width: 60%;
          height: 100%;
          background-color: black;
          object-fit: contain;
          margin-bottom: 10px;
        }
      }
    }
  }
}
.safe-bottom {
  height: 150px;
}

.text111{
  font-weight: 400;
  font-size: 9 * 2px;
  // line-height: 32px;
  color: #828393;
  // background: #fff;
  margin-top: 20 * 2px;
  // padding: 30px;
  width: 343 * 2px;
}

.text111 *{
  line-height: 19 * 2px;
  font-size: 9 * 2px;
  opacity: 0.7;
}

</style>
